exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".active {\n  color: #fff;\n}\n.navbar-toggler {\n  border: solid 1px silver;\n  border-radius: 2px;\n  color: #eee;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/navbar/navbar.component.css
// module id = 454
// module chunks = 1